var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17 21-.48-1.154A3 3 0 0 0 13.75 18h-3.5a3 3 0 0 0-2.77 1.846L7 21M12 12v9M21.25 7c0 .944-.784 2-2.514 2.865-1.685.842-4.066 1.385-6.736 1.385s-5.05-.543-6.736-1.385C3.534 9 2.75 7.944 2.75 7c0-.944.784-2 2.514-2.865C6.95 3.293 9.33 2.75 12 2.75s5.05.543 6.736 1.385C20.466 5 21.25 6.056 21.25 7Z"
})));
SvgTable.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export default ForwardRef;